<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getRem } from './utils/validate'

export default {
  name: 'App',
  mounted () {
    getRem(window)
  }
}
</script>

<style>
@import url('./assets/css/reset.less');
#app {
  padding: 54px 0 10px 0;
  width: 100%;
  /* height: 100%; */
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F4F6FA;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue